(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        var initialized = false;
        observer.unobserve(cartRecommendationsSection);

        const productIds = JSON.parse(cartRecommendationsSection.dataset.productIds);
        productIds.forEach((productId) => {
            if (initialized) {
                return;
            }

            const url = cartRecommendationsSection.dataset.url + '&product_id=' + productId;
            fetch(url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('.cart-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        console.log(cartRecommendationsSection);
                        if (cartRecommendationsSection.innerHTML.trim().length <= 0) {
                            cartRecommendationsSection.innerHTML = recommendations.innerHTML;
                        } else {
                            $(cartRecommendationsSection).find('.slick_product_recommendations').append($(recommendations).find('.slick_product_recommendations').html());
                            $('.slick_product_recommendations').slick('refresh');
                            return;
                        }
                        $('.slick_product_recommendations').slick({
                            arrows: true,
                            infinite: false,
                            dots: false,
                            speed: 300,
                            slidesToShow: 4,
                            slidesToScroll: 3,
                            autoplay: true,
                            autoplaySpeed: 2000,
                            rtl: cartRecommendationsSection.dataset.enableRtlMode,
                            prevArrow: '<button type="button" class="prev-slide" aria-label="Précédent"><i class="fa fa-angle-left"></i> </button>',
                            nextArrow: '<button type="button" class="next-slide" aria-label="Suivant"> <i class="fa fa-angle-right"></i></button>',
                            responsive: [
                                {
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 4,
                                        arrows: true,
                                        infinite: false,
                                        dots: false,
                                    }
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 2,
                                    }
                                },
                                {
                                    breakpoint: 600,
                                    settings: {
                                        slidesToShow: 2,
                                        arrows: true,
                                        infinite: false,
                                        dots: false,
                                    }
                                }
                            ]
                        });
                        initialized = true;
                    }
                })
                .catch(e => {
                    console.error(e);
                })
            ;
        });
    };

    const cartRecommendationsSection = document.querySelector('.cart-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(cartRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url + '&product_id=' + productRecommendationsSection.dataset.productId;

        fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
                window.yotpoWidgetsContainer && yotpoWidgetsContainer.initWidgets();
                $('.slick_product_recommendations').slick({
                    arrows: true,
                    infinite: false,
                    dots: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    rtl: productRecommendationsSection.dataset.enableRtlMode,
                    prevArrow: '<button type="button" class="prev-slide" aria-label="Précédent"><i class="fa fa-angle-left"></i> </button>',
                    nextArrow: '<button type="button" class="next-slide" aria-label="Suivant"> <i class="fa fa-angle-right"></i></button>',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                                arrows: true,
                                infinite: false,
                                dots: false,
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                arrows: true,
                                infinite: false,
                                dots: false,
                            }
                        }
                    ]
                });
            }
        })
        .catch(e => {
            console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
